var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("XML készítő")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/out"}},[_vm._v("KIRA OUT")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }